import { useDesktopOnly } from '../hooks/useDesktopOnly';
import {type ReactNode} from "react";

export default function DesktopOnlyGuard({ children }: { children: ReactNode }) {
    const isDesktop: boolean = useDesktopOnly();

    if (!isDesktop) {
        return (
            <div className="fixed bg-base-200 h-screen w-screen flex items-center justify-center z-50 p-4">
                <div className="text-center text-neutral-primary max-w-md">
                    <h1 className="text-3xl font-bold mb-4">PC uniquement</h1>
                    <p className="text-lg mb-8">Ce site nécessite un ordinateur. Ouvrez-le sur un PC ou tablette large.</p>
                </div>
            </div>
        );
    }

    return <>{children}</>;
}
